import React, { useState } from "react";
import TextCTA from "../TextCTA/TextCTA";
import "./CheckboxGroup.css";

interface CheckboxGroupProps {
  title: string;
  options: { label: string; value: string; disabled?: boolean }[]; // Updated to include disabled
  selectedValues?: string[]; // Optional controlled state
  hasTextCTA?: boolean;
  CTAText?: string;
  hasIcon?: boolean;
  iconPath?: string;
  onSelectionChange?: (selected: string[]) => void; // Callback for changes
}

const CheckboxGroup = ({
  title,
  options,
  selectedValues: controlledValues,
  hasTextCTA,
  CTAText = "",
  hasIcon = false,
  iconPath = "",
  onSelectionChange,
}: CheckboxGroupProps) => {
  const [localSelectedValues, setLocalSelectedValues] = useState<string[]>([]);

  // Use controlledValues if provided, otherwise fall back to local state
  const selectedValues =
    controlledValues !== undefined ? controlledValues : localSelectedValues;

  const handleCheckboxChange = (value: string) => {
    if (options.find((opt) => opt.value === value)?.disabled) return; // Prevent change if disabled
    const newSelected = selectedValues.includes(value)
      ? selectedValues.filter((item) => item !== value)
      : [...selectedValues, value];

    if (controlledValues === undefined) {
      // Uncontrolled mode: update local state
      setLocalSelectedValues(newSelected);
    }
    onSelectionChange?.(newSelected); // Always notify parent
  };

  return (
    <div className="checkbox-group">
      <div className="checkbox-group-title-section">
        <h3>{title}</h3>
        {hasTextCTA && (
          <TextCTA hasIcon={hasIcon} iconPath={iconPath} text={CTAText} />
        )}
      </div>

      {options.map((option) => (
        <label key={option.value} className="checkbox-label">
          <input
            type="checkbox"
            value={option.value}
            checked={selectedValues.includes(option.value)}
            onChange={() => handleCheckboxChange(option.value)}
            disabled={option.disabled} // Apply disabled attribute
          />
          <span>{option.label}</span>
        </label>
      ))}
    </div>
  );
};

export default CheckboxGroup;
